import React from 'react';
import { Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FONT_SIZE } from './types';
import LabeledContent from './DataCatalogSyncResultLabeledContent';
var ITEM_PADDING = { padding: '0 5px' };
export default function Changes(_a) {
    var title = _a.title, _b = _a.changes, created = _b.created, updated = _b.updated, obsoleted = _b.obsoleted, outdated = _b.outdated;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, flex: 3, sx: ITEM_PADDING },
                React.createElement(Stack, { direction: "column", sx: { height: '100%' }, justifyContent: "end" },
                    React.createElement(Typography, { fontSize: FONT_SIZE, noWrap: true }, title))),
            React.createElement(Grid, { item: true, flex: 1, sx: ITEM_PADDING },
                React.createElement(LabeledContent, { label: "Created", align: "right" },
                    React.createElement(Typography, { fontSize: FONT_SIZE, textAlign: "right" }, created))),
            React.createElement(Grid, { item: true, flex: 1, sx: ITEM_PADDING },
                React.createElement(LabeledContent, { label: "Updated", align: "right" },
                    React.createElement(Typography, { fontSize: FONT_SIZE, textAlign: "right" }, updated))),
            React.createElement(Grid, { item: true, flex: 1, sx: ITEM_PADDING },
                React.createElement(LabeledContent, { label: "Obsoleted", align: "right" },
                    React.createElement(Typography, { fontSize: FONT_SIZE, textAlign: "right" }, obsoleted))),
            React.createElement(Grid, { item: true, flex: 1, sx: ITEM_PADDING },
                React.createElement(LabeledContent, { label: "Outdated", align: "right" },
                    React.createElement(Typography, { fontSize: FONT_SIZE, textAlign: "right" }, outdated))))));
}
//# sourceMappingURL=DataCatalogSyncResultChanges.js.map